import { gql, useQuery } from 'urql';
export const GET_QR_QUERY = gql`
  query GetTicketQrcodeById($id: Int!) {
    getTicketQrcodeById(input: { ticketId: $id, qrCodeSize: 256 }) {
      firstName
      lastName
      qr
    }
  }
`;

export interface IQrResponse {
  getTicketQrcodeById: {
    firstName: string;
    lastName: string;
    qr: string;
  };
}

export const useFetchTicketQr = (id: number) => {
  const [result, reexecuteQuery] = useQuery<IQrResponse>({
    query: GET_QR_QUERY,
    variables: { id },
    pause: !id,
    requestPolicy: 'network-only',
  });
  return { ...result, reexecuteQuery };
};
